import React, { useState } from 'react';

function VillageGallery({ gallery }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  if (!gallery || gallery.length === 0) {
    return null;
  }

  const openImage = (image) => {
    setSelectedImage(image);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeImage = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <div className="gallery-section">
        <h2 className="section-title">फोटो गैलरी</h2>
        <div className="gallery-grid">
          {gallery.map(item => (
            <div
              key={item.id}
              className="gallery-item"
              onClick={() => openImage(item)}
            >
              <img src={item.image} alt={item.caption} />
              <div className="gallery-caption">{item.caption}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && selectedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}
          onClick={closeImage}
        >
          <div
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%'
            }}
            onClick={e => e.stopPropagation()}
          >
            <img
              src={selectedImage.image}
              alt={selectedImage.caption}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                borderRadius: '8px'
              }}
            />
            <button
              onClick={closeImage}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'white',
                border: 'none',
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                fontSize: '24px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#333'
              }}
            >
              ✕
            </button>
            <p style={{
              color: 'white',
              textAlign: 'center',
              marginTop: '15px',
              fontSize: '1rem'
            }}>
              {selectedImage.caption}
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default VillageGallery;
